import { memo } from "react";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrDivider from "UI/FnrDivider/FnrDivider";
import FnrDragNDrop from "UI/FnrDragNDrop/FnrDragNDrop";

import ItemComponent from "./ItemComponent/ItemComponent";

const FnrDragNDropMemo = memo(FnrDragNDrop);

const FieldDragList = () => {
  const items = extendedFieldHooks.useFieldDragItems();
  const isProfileVariant = extendedFieldHooks.useVariant() === "profile";

  const [isLoading, updateExtendedFieldOrder] =
    extendedFieldHooks.useUpdateExtendedFieldOrder();

  return (
    <>
      {Boolean(items.length) && isProfileVariant && <FnrDivider />}
      <FnrDragNDropMemo
        ItemComponent={ItemComponent}
        items={items}
        itemIdName="id"
        itemHasDragTrigger
        onRelease={updateExtendedFieldOrder}
        noMargin
        disabled={isLoading}
      />
    </>
  );
};

export default FieldDragList;
